import { Component } from '@angular/core';

import styles from './VgScrubBarScrubber.module.less';

@Component({
	selector: 'vg-scrub-bar-scrubber',
	host: {
		'[class]': 'styles.root'
	},
	template: `
		<div [ngClass]="styles.scrubber"></div>
	`
})
export class VgScrubBarScrubberComponent {
	public readonly styles = styles;
}
